export const availableLanguages: { [key: string]: string } = {
  'en-US': 'en',
  'pt-BR': 'pt-BR',
  'es-AR': 'es-AR',
  'es': 'es',
  'fr': 'fr',
  'it': 'it',
  'pl': 'pl',
  'de': 'de',
};

export const fixLang = (language: string) => {
  switch (language) {
    case 'pt-BR':
      return 'pt_br';
    case 'es-AR':
      return 'es_ar';
    default:
      return language;
  }
};
